import { CalculatorRembursement } from '../../components/CalculatorRembursement';
import { SharedInputEdit } from '../../components/SharedInputEdit';

export function ClinicalExaminationsInput(): JSX.Element {
    return (
        <div className="examinations">
            <SharedInputEdit inputName='average_number_scans'/>
            <CalculatorRembursement/>

            <div className="price">
                <div>
                    <SharedInputEdit inputName='high_examination_mix_price'/>
                    <SharedInputEdit inputName='medium_examination_mix_price'/>
                    <SharedInputEdit inputName='low_examination_mix_price'/>
                </div>
                <div>
                    <SharedInputEdit inputName='high_examination_mix_percent'/>
                    <SharedInputEdit inputName='medium_examination_mix_percent'/>
                    <SharedInputEdit inputName='low_examination_mix_percent'/>
                </div>
            </div>
        </div>
    );
}
